export default {
  Title: 'Work Eligibility',
  Subtitle: 'What\'s your current work authorization status in Canada?',
  WorkAuthorizationTitle: 'Work Authorization Status',
  WorkAuthorizationDescription: 'Select your current work authorization status',
  Options: {
    CitizenPermanent: {
      Label: 'Citizen/Permanent Resident',
      Description: 'Authorized to work without restrictions',
    },
    TemporaryResident: {
      Label: 'Temporary Resident',
      Description: 'Temporary work permit holder',
    },
    SeekingSponsorship: {
      Label: 'Seeking Sponsorship',
      Description: 'Need employer sponsorship',
    },
    Other: {
      Label: 'Other',
      Description: 'Other work authorization status',
    },
  },
  ImportantInfo: {
    Title: 'Important Info',
    Message: 'We are required to verify work eligibility for all caregivers. Documentation will be requested during the application review process.',
  },
  Summary: {
    Title: 'Your Work Eligibility Status',
  },
};
